export default "__VITE_ASSET__DA3ktF_z__"